<!-- Component Header Placeholder -->
<app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

<div class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-orange-50 font-sans">
    <!-- Decorative Background Elements -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
        <div
            class="absolute -top-40 -right-40 w-80 h-80 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob">
        </div>
        <div
            class="absolute -bottom-40 -left-40 w-80 h-80 bg-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000">
        </div>
        <div
            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000">
        </div>
    </div>

    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-2 py-2">
        <!-- Header Section with Enhanced Styling -->
        <div class="mb-8 text-center sm:text-left">
            <div class="flex items-center justify-center sm:justify-start gap-4 mb-3">
                <div class="relative">
                    <div
                        class="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-orange-500/30 transform hover:scale-105 transition-transform duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" viewBox="0 0 20 20"
                            fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div
                        class="absolute -inset-1 bg-orange-500 rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition">
                    </div>
                </div>
                <div>
                    <h1
                        class="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                        Complete Your Payment</h1>
                    <p class="text-gray-500 mt-1 flex items-center gap-2">
                        <span class="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></span>
                        Secure checkout process
                    </p>
                </div>
            </div>
            <div class="h-1 w-32 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full mx-auto sm:mx-0"></div>
        </div>

        <!-- Main Payment Card -->
        <div class="max-w-lg mx-auto">

            <div
                class="bg-white/80 backdrop-blur-xl shadow-2xl rounded-3xl overflow-hidden border border-white/20 relative group">
                <!-- Shine Effect -->
                <div
                    class="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
                </div>

                <!-- Progress Bar & Tab Header -->
                <div class="p-6 sm:p-2 bg-white border-b border-gray-100">
                    <!-- Enhanced Progress Bar -->
                    <div *ngIf="value" class="mb-6 relative">
                        <div class="flex justify-between text-xs text-gray-500 mb-2">
                            <span>Payment Initiated</span>
                            <span>Processing</span>
                            <span>Completed</span>
                        </div>
                        <div class="w-full bg-gray-100 rounded-full h-3 overflow-hidden">
                            <div class="bg-gradient-to-r from-teal-500 to-teal-600 h-full flex items-center justify-center text-white text-xs font-bold transition-all duration-700 relative"
                                [style.width]="value + '%'">
                                <span class="absolute right-1 text-[10px]">{{ value }}%</span>
                            </div>
                        </div>
                    </div>

                    <!-- Enhanced Status Indicator -->
                    <div class="bg-gray-100 p-2 rounded-2xl">
                        <div *ngIf="!isShowUpi"
                            class="bg-gradient-to-r from-amber-50 to-yellow-50 text-amber-700 py-4 px-4 rounded-xl text-center font-semibold shadow-sm border border-amber-200 flex items-center justify-center gap-2">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                                </path>
                            </svg>
                            Select Payment Method
                        </div>
                        <div *ngIf="isShowUpi"
                            class="bg-gradient-to-r from-teal-600 to-teal-500 text-white py-4 px-4 rounded-xl text-center font-semibold shadow-lg flex items-center justify-center gap-2">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                                </path>
                            </svg>
                            Pay With UPI
                        </div>
                    </div>
                </div>

                <!-- Card Body / Form Section -->
                <div class="p-6 sm:p-4">
                    <form id="nonseamless" ngNoForm method="post" class="space-y-8">
                        <div class="text-center">
                            <label class="block text-gray-600 font-medium mb-4 uppercase tracking-wider text-xs">
                                Amount to pay
                            </label>

                            <!-- Enhanced Amount Display -->
                            <div class="relative max-w-[280px] mx-auto">
                                <div
                                    class="absolute inset-0 bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl blur-xl opacity-20">
                                </div>
                                <div
                                    class="relative bg-white border-2 border-gray-100 rounded-2xl shadow-lg overflow-hidden group-hover:border-orange-200 transition-colors duration-300">
                                    <span
                                        class="absolute left-6 top-1/2 -translate-y-1/2 text-gray-400 font-medium text-lg">₹</span>
                                    <input *ngIf="!isShowUpi" type="text" readonly
                                        class="w-full pl-12 pr-6 py-5 bg-transparent text-center text-3xl font-bold text-gray-900 focus:ring-0 outline-none"
                                        [value]="amount | number: '1.2-2'">
                                    <input *ngIf="isShowUpi" type="text" readonly
                                        class="w-full pl-12 pr-6 py-5 bg-transparent text-center text-3xl font-bold text-gray-900 focus:ring-0 outline-none"
                                        [value]="availabeAmount | number: '1.2-2'">
                                </div>
                            </div>
                        </div>
                    </form>

                    <!-- Enhanced Payment Button -->
                    <div class="mt-8" *ngIf="!isShowUpi">
                        <button type="button" (click)="payWithCCavenue()"
                            class="relative w-full group overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
                            <!-- Button Background with Gradient -->
                            <div
                                class="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700 group-hover:from-blue-700 group-hover:to-blue-800 transition-all duration-300">
                            </div>

                            <!-- Shine Effect -->
                            <div
                                class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700">
                            </div>

                            <!-- Button Content -->
                            <div class="relative py-5 px-8 flex items-center justify-center space-x-3">
                                <span class="text-white font-bold text-lg">Pay through Gateway</span>
                                <span
                                    class="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-white font-bold text-sm border border-white/30">
                                    ₹{{availabeAmount | number: '1.2-2'}}
                                </span>
                                <svg class="w-5 h-5 text-white transform group-hover:translate-x-1 transition-transform"
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5l7 7-7 7"></path>
                                </svg>
                            </div>
                        </button>
                    </div>
                </div>

                <!-- Enhanced Footer Note -->
                <div class="bg-gradient-to-r from-gray-50 to-white px-6 py-4 border-t border-gray-100">
                    <div class="flex flex-wrap items-center justify-center gap-4 text-xs">
                        <p class="text-gray-500 flex items-center gap-1.5">
                            <svg class="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span>Secure SSL Encrypted</span>
                        </p>
                    </div>
                </div>
            </div>

            <!-- Help Link -->
            <div class="text-center mt-6">
                <a href="#"
                    class="text-sm text-gray-400 hover:text-orange-500 transition-colors inline-flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                    </svg>
                    Need help with payment?
                </a>
            </div>
        </div>
    </div>
</div>

<style>
    @keyframes blob {

        0%,
        100% {
            transform: translate(0, 0) scale(1);
        }

        33% {
            transform: translate(30px, -50px) scale(1.1);
        }

        66% {
            transform: translate(-20px, 20px) scale(0.9);
        }
    }

    .animate-blob {
        animation: blob 7s infinite;
    }

    .animation-delay-2000 {
        animation-delay: 2s;
    }

    .animation-delay-4000 {
        animation-delay: 4s;
    }
</style>